import data from './data';
import pages from './pages';
import user from './user';
import softLogin from './softLogin';

export default {
    data,
    pages,
    user,
    softLogin,
};
